import { api } from '@lipaflow/shared'

export interface Notification {
  id: string
  tenant_id: string
  user_id: string
  title: string
  body: string | null
  category: string
  link: string | null
  is_read: boolean
  read_at: string | null
  created_at: string
  updated_at: string
}

export interface NotificationListResponse {
  items: Notification[]
  total: number
  page: number
  per_page: number
  pages: number
}

export interface UnreadCountResponse {
  count: number
}

export const notificationService = {
  async list(page = 1, per_page = 20, is_read?: boolean): Promise<NotificationListResponse> {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('per_page', per_page.toString())
    if (is_read !== undefined) params.append('is_read', is_read.toString())

    const response = await api.get<NotificationListResponse>(`/notifications?${params}`)
    return response.data
  },

  async getUnreadCount(): Promise<UnreadCountResponse> {
    const response = await api.get<UnreadCountResponse>('/notifications/unread-count')
    return response.data
  },

  async markAsRead(id: string): Promise<Notification> {
    const response = await api.post<Notification>(`/notifications/${id}/read`)
    return response.data
  },

  async markAllAsRead(): Promise<UnreadCountResponse> {
    const response = await api.post<UnreadCountResponse>('/notifications/read-all')
    return response.data
  },
}

/**
 * The address of the notification stream, with a one-time ticket.
 *
 * EventSource can't send an Authorization header. The sign-in token used to
 * ride in the address, where request logs kept it; now the header-signed
 * request below buys a ticket that opens one connection, once, within a
 * minute. Each reconnect asks for a fresh one.
 */
export async function getStreamUrl(): Promise<string | null> {
  try {
    const response = await api.post<{ ticket: string }>('/notifications/stream-ticket')
    const baseUrl = api.defaults.baseURL || ''
    return `${baseUrl}/notifications/stream?ticket=${encodeURIComponent(response.data.ticket)}`
  } catch {
    return null
  }
}
